"use strict";
/**
 * @module Client.Services
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Notify subscriptions
 */
exports.notifySubscriptionService = {
    /**
     * Handle an inbound request.
     *
     * @param internal      the internal session instance
     * @param notification  the inbound notification
     * @param callback      the service reference callback
     */
    onRequest: function (internal, request, callback) {
        callback.respond();
        internal.getRouting().subscribe(request);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/client/services/notify-subscription-service.js
// module id = 1424
// module chunks = 1